<template>
  <div class="flex flex-row items-start mb-4 lg:mb-0">
    <label class="text-sm font-semibold text-secondary-600 block mb-1 mt-1 cursor-pointer">{{title}}
      <div class="flex items-center mt-2">
        <input type="checkbox" value="" class="sr-only peer">
        <div class="relative w-9 h-5 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
        <span class="ml-2 text-sm font-medium text-secondary-900 dark:text-secondary-300">{{titleActive}}</span>
      </div>
    </label>
  </div>
</template>

<script>
export default {
  name: 'toggle',
  props: {
    title: {
      type: String,
      default: ''
    },
    titleActive: {
      type: String,
      default: ''
    },
  },
  mounted: function () {
  },
  methods: {
  }
}
</script>
